import React from "react";

export const Footer = () => {
    return(
        <footer className="footer">
            <h3 >&copy; Kristiina Kolu</h3>
            <h3 >Technigo Boot Camp spring '22, week 11 project</h3>
        </footer>
    )
}